import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";

import userAuthSlice from "./slices/userAuthSlice"; // Assuming you have a userSlice

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userAuthSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});

const persistor = persistStore(store);

export { store, persistor };
